module.exports = __webpack_public_path__ + "static/media/sama9.6a901c59.wav";